import getPitch from './pitch-detection';
import p5 from 'p5';
import 'p5/lib/addons/p5.sound';
import 'p5/lib/addons/p5.dom';

import mouseMovedInLast2Seconds, {
  updateMouseMoved,
} from './mouse-moved-in-last-2-seconds';
import {drawWaterColorBrush} from './watercolor';

export default function sketch(p) {
  let source, fft, lowPass;
  let amplitude;
  let brush = watercolorBrush;
  let noteName;
  let targetFrequency;
  const squareSize = 50;

  function frequencyToColor(freq) {
    const COLORS = [
      '#FF0001',
      '#FF4401',
      '#D66F01',
      '#FFC503',
      '#E0EA03',
      '#76D102',
      '#01FFAB',
      '#00FFE7',
      '#00B2FF',
      '#3409FF',
      '#9E07FF',
      '#FF03FD',
    ];
    const NOTE_FREQUENCIES = [
      16.35,
      17.32,
      18.35,
      19.45,
      20.6,
      21.83,
      23.12,
      24.5,
      25.96,
      27.5,
      29.14,
      30.87,
    ];
    let i = 0;
    let j = 0;
    while (i < 200) {
      NOTE_FREQUENCIES.push(NOTE_FREQUENCIES[j] * 2);
      j++;
      i++;
    }
    const NOTES = [
      'C',
      'C#',
      'D',
      'D#',
      'E',
      'F',
      'F#',
      'G',
      'G#',
      'A',
      'A#',
      'B',
    ];

    const level = amplitude.getLevel();
    if (level < 0.001) {
      return 'black';
    }

    // const nfreq = normalizeToFit(NOTE_FREQUENCIES, freq);
    p.fill(0);
    // text ('Estimated Low Frequency: ' + nfreq.toFixed(2), 20, 20);
    const note = findClosest(NOTE_FREQUENCIES, freq);
    const index = NOTE_FREQUENCIES.indexOf(note);
    const nindex = index % COLORS.length;
    const color = COLORS[nindex];
    noteName = NOTES[nindex];
    targetFrequency = note;

    return color;
  }

  function findClosest(arr, value) {
    const distances = arr.map(v => Math.abs(v - value));
    const mindist = p.min(distances);
    return arr[distances.indexOf(mindist)];
  }

  function watercolorBrush({level, spectrumColor, x, y}) {
    drawWaterColorBrush(p, x, y, level * 800, spectrumColor);
  }

  function circleBrush({level, spectrumColor, x, y}) {
    p.fill(colorAlpha(spectrumColor, 0.1 + level));
    p.ellipse(x, y, level * 500, level * 500);
  }

  function colorAlpha(aColor, alpha) {
    var c = p.color(aColor);
    return p.color(
      'rgba(' + [p.red(c), p.green(c), p.blue(c), alpha].join(',') + ')',
    );
  }

  function squareBrush({level, spectrumColor, x, y}) {
    p.fill(spectrumColor);
    p.beginShape();
    const size = level * 1000;
    p.vertex(x - size, y - size);
    p.vertex(x - size, y + size);
    p.vertex(x + size, y + size);
    p.vertex(x + size, y - size);
    p.endShape(p.CLOSE);
  }

  p.myCustomRedrawAccordingToNewPropsHandler = function myCustomRedrawAccordingToNewPropsHandler(
    props,
  ) {};

  p.setup = function setup() {
    console.log('creating canvas');
    p.createCanvas(p.windowWidth, p.windowHeight);
    p.noFill();

    // uncomment me to use mic
    source = new p5.AudioIn();
    source.start();

    // source.play(); // comment me to use mic

    amplitude = new p5.Amplitude();
    amplitude.setInput(source);

    lowPass = new p5.LowPass();
    lowPass.disconnect();
    source.connect(lowPass);

    fft = new p5.FFT();
    fft.setInput(lowPass);

    p.background(0);

    // const squareBrushButton = p5.createButton('Square Brush');
    // squareBrushButton.position(p.width - 100, p.height - 20);
    // squareBrushButton.mousePressed(() => (brush = squareBrush));
    // const circleBrushButton = p5.createButton('Circle Brush');
    // circleBrushButton.position(p.width - 100, p.height - 40);
    // circleBrushButton.mousePressed(() => (brush = circleBrush));
    backgroundColor = colorAlpha(0, 0.025);
    lineColor = colorAlpha(255, 0.03);
  };

  let storedEllipses = [];
  let backgroundColor;
  let lineColor;
  let translateX = 0;
  let translateY = 0;
  let rotate = 0;
  let stepX = 1;
  let stepY = 1;
  p.draw = function draw() {
    p.background(backgroundColor);
    p.translate(p.width / 2, p.height / 2);

    p.noFill();

    const timeDomain = fft.waveform(1024, 'float32');
    const freq = getPitch(p, timeDomain);
    const spectrumColor = frequencyToColor(freq);
    const level = amplitude.getLevel();

    p.onChange &&
      p.onChange({
        frequency: freq,
        spectrumColor,
        targetFrequency,
        noteName,
        level,
      });

    p.noStroke();
    // p.stroke(255)

    p.noFill();
    p.stroke(lineColor);
    p.translate(translateX, translateY);
    for (let i = -p.width / 2; i < p.width / 2; i += squareSize) {
      for (let j = -p.height / 2; j < p.height / 2; j += squareSize) {
        const mouseX = p.mouseX - p.width / 2;
        const mouseY = p.mouseY - p.height / 2;
        if (
          mouseMovedInLast2Seconds(p) &&
          mouseX > i &&
          mouseY > j &&
          mouseX < i + squareSize &&
          mouseY < j + squareSize
        ) {
          p.fill(
            spectrumColor === 'black'
              ? colorAlpha('white', 0.6)
              : spectrumColor,
          );
          p.translate(-translateX, -translateY);
          p.rect(i, j, squareSize, squareSize);
          p.noFill();
          p.stroke(lineColor);
          p.translate(translateX, translateY);
        }

        if (!mouseMovedInLast2Seconds(p) && Math.random() > 1 - level / 20) {
          p.fill(colorAlpha(spectrumColor, 0.5));
          const sizeX = squareSize * Math.floor(p.random([2, 4, 6]));
          const sizeY = squareSize * Math.floor(p.random([2, 4, 6]));
          p.rect(i - sizeX / 2, j - sizeY / 2, sizeX, sizeY);
          p.noFill();
          p.stroke(lineColor);
        }

        if (Math.random() > 0.4) {
          p.rect(i, j, i + squareSize, j + squareSize);
        }
      }
    }

    translateX += stepX * (50 * level);
    translateY += stepY * (50 * level);
    rotate += 0.001;

    if (translateX > squareSize || translateX < 0) {
      stepX *= -1;
    }

    if (translateY > squareSize || translateY < 0) {
      stepY *= -1;
    }

    if (Math.random() > 0.99) {
      stepX *= -1;
    }

    if (Math.random() > 0.99) {
      stepY *= -1;
    }

    updateMouseMoved(p);
  };

  p.touchStarted = function touchStarted() {
    p.getAudioContext().resume();
  };
}



// WEBPACK FOOTER //
// ./src/sketches/moving-lines.js